import { Flex } from 'antd';
import React from 'react';

import { StatusCircle } from '@entities';

import * as S from './styled';

type DocumentExpenseAmountStatusProps = {
  isEqual: boolean;
  label: React.ReactNode;
};

const DocumentExpenseAmountStatus = ({
  isEqual,
  label,
}: DocumentExpenseAmountStatusProps) => (
  <Flex gap={8}>
    <StatusCircle status={isEqual ? 'completed' : 'errorsFound'} />
    <S.Status>{label}</S.Status>
  </Flex>
);

export default DocumentExpenseAmountStatus;
